module.exports = __webpack_public_path__ + "static/media/inbox_model_2x.4df6b0f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/brite/inbox_model_2x.png
// module id = 283
// module chunks = 0